<div
  class="mat-elevated-item w-100 d-flex flex-wrap flex-column align-items-center"
>
  @for (row of data(); track $index) {
  <div class="w-100 s-p-4 border border-bottom-0">
    <div class="mobile-header d-flex flex-wrap justify-content-between">
      @for (column of displayedColumns; track $index) {
      <div class="header-column">
        <strong>
          {{ column.name }}
        </strong>
        <app-table-cell [column]="column" [row]="row"> </app-table-cell>
      </div>
      }
      <div class="expand-column d-flex justify-content-center">
        <button mat-icon-button (click)="row.isOpen = !row.isOpen">
          <mat-icon [ngClass]="{ opened: row.isOpen }"> expand_more </mat-icon>
        </button>
      </div>
    </div>
    <div
      [ngClass]="{ 'd-none': !row.isOpen, 'd-flex': row.isOpen }"
      class="s-mt-3 gap-1 flex-wrap justify-content-between align-items-center"
    >
      <div *ngFor="let column of hidedColumns">
        <strong>
          {{ column.name }}
        </strong>
        <app-table-cell [column]="column" [row]="row"> </app-table-cell>
      </div>
    </div>
    <div class="actions d-flex s-mt-3 justify-content-end gap-1 flex-wrap">
      @for (action of actions(); track $index) {
      <app-action-button [row]="row" [action]="action"> </app-action-button>
      }
    </div>
  </div>
  }
</div>
